import BaseFormPresenter from "../../../../../base/BaseFormPresenter";

class WasteProductFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default WasteProductFormPresenter;
